import React, { useEffect, useState } from "react";
import { Select, Space, Spin } from "antd";
import { usePermissions } from "../../../PermissionsProvider";
import { ApplicationService } from "../../../services/ApplicationService";
import { Application, ApplicationAction } from "../../../model_gen/application";
import StepHeader from "../StepHeader";

interface SelectIntentProps {
  application?: Application;
  value?: ApplicationAction;
  onChange: (intent: ApplicationAction) => void;
}

const SelectIntent: React.FC<SelectIntentProps> = ({
  application,
  value,
  onChange,
}) => {
  const { apiKey } = usePermissions();
  const [intents, setIntents] = useState<ApplicationAction[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (application) {
      setLoading(true);
      ApplicationService.getApplicationActions(
        application.id,
        null,
        apiKey
      ).subscribe(
        (actions: ApplicationAction[]) => {
          setIntents(actions ?? []);
          setLoading(false);
        },
        (error: any) => {
          console.error("Error fetching intents:", error);
          setLoading(false);
        }
      );
    }
  }, [application, apiKey]);

  if (loading) {
    return (
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <StepHeader
          title="Select Intent"
          description="Choose the intent to evaluate"
        />
        <Spin />
      </Space>
    );
  }

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StepHeader
        title="Select Intent"
        description="Choose the intent to evaluate"
      />

      <Select
        style={{ width: "100%", maxWidth: "500px" }}
        value={value?.id}
        onChange={(intentId: number) => {
          const selectedIntent = intents.find(
            (intent) => intent.id === intentId
          );
          if (selectedIntent) {
            onChange(selectedIntent);
          }
        }}
        placeholder="Select an intent"
        showSearch
        optionFilterProp="children"
        disabled={!application}>
        {intents.map((intent: ApplicationAction) => (
          <Select.Option key={intent.id} value={intent.id}>
            {intent.action_type}
          </Select.Option>
        ))}
      </Select>
    </Space>
  );
};

export default SelectIntent;
